import React from "react";
import PropTypes from "prop-types";
import { useManufacturers } from "api/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";

import StepsListView from "../views/StepsListView";

const ManufacturersList = ({ className }) => {
  const classes = ["ManufacturersList"];
  if (className) classes.push(className);

  const navigate = useNavigate();
  const location = useLocation();

  function handleClick(item) {
    const { iframe = false } = queryString.parse(location.search);

    if (item.engine_types_id && item.specifications_id) {
      navigate(`search_selector?manufacturerid=${item.id}&iframe=${iframe}`);
    } else {
      if (item.engine_types_id) {
        navigate(
          `/engine_model_group?manufacturerid=${item.id}&groupid=${item.engine_types_id}&iframe=${iframe}`
        );
      }

      if (item.specifications_id) {
        navigate(
          `/specification_group?manufacturerid=${item.id}&groupid=${item.specifications_id}&iframe=${iframe}`
        );
      }
    }
  }

  const { data } = useManufacturers();
  // mapping the data list
  const steps = data
    ? data.map((d) => {
        const label = d.name;
        return {
          label,
          key: d.id,
          ...d,
        };
      })
    : data;
  return <StepsListView list={steps} onClick={handleClick} />;
};

ManufacturersList.displayName = "ManufacturersList";

ManufacturersList.propTypes = {
  className: PropTypes.string,
};

ManufacturersList.defaultProps = {
  className: null,
};

export default ManufacturersList;
